import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from '../../Constants/endpoints'
import { IAuthenticatedUser, LoginPatchRequest, SSOGenerateRequest, SSOGenerationResponse } from '../../Interfaces/general'
import { foundationUrlQuery } from './baseQuery';


export const authenticationApi = createApi({
  reducerPath: "authenticationApi",
  baseQuery: foundationUrlQuery,
  endpoints: (builder) => ({
    generateSSOURL: builder.mutation<SSOGenerationResponse, SSOGenerateRequest>({
      query: (body) => ({
        url: API_ENDPOINTS.GENERATE_SSO_URL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Source: "Web",
          Lang: "EN",
        },
        body:body
      })
    }),
    loginWithSSOToken: builder.query<IAuthenticatedUser, string>({
      query: (token: string) => ({
        url: API_ENDPOINTS.SSO_LOGIN,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Source: "Web",
          Lang: "EN",
          Authorization: `Token ${token}`,
        },
      }),
    }),
    loginPatchAPI: builder.mutation<any, LoginPatchRequest>({
      query: (request) => ({
        url: API_ENDPOINTS.LOGIN_PATCH + request.id,
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Source: "Web",
          Lang: "EN",
          Authorization: `Token ${request.token}`,
        },
        body: {
          extrainfo: {
            ...request.extraInfo
          },
          address2:request.address2,
          firstname:request.firstname,
          lastname:request.lastname,
          emailid:request.emailid,
          phone:request.phone,
          address:request.address,
        }
      })
    })
  }),
});

export const { useLoginWithSSOTokenQuery, useLoginPatchAPIMutation, useLazyLoginWithSSOTokenQuery, useGenerateSSOURLMutation } = authenticationApi